var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "dashboard-block" }, [
    _vm.state === "completed"
      ? _c("h2", [_vm._v("Upload Complete")])
      : _vm._e(),
    _vm._v(" "),
    _vm.state === "open" ? _c("h2", [_vm._v("Upload a Video")]) : _vm._e(),
    _vm._v(" "),
    _vm.state === "preview" || _vm.state === "uploading"
      ? _c("h2", [_vm._v("Confirm Your Video")])
      : _vm._e(),
    _vm._v(" "),
    _vm.state === "open"
      ? _c("p", [
          _vm._v(
            "Upload your video below. You will be able to preview your video when the upload completes."
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.state === "preview" || _vm.state === "uploading"
      ? _c("p", [
          _vm._v(
            "Complete your booking when you are satisfied with the uploaded video."
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.state === "completed"
      ? _c("div", { staticClass: "videoUpload_video" }, [
          _vm.booking.video_link
            ? _c("iframe", {
                attrs: { src: _vm.booking.video_link, frameborder: "0" },
              })
            : _c("div", { staticClass: "videoUpload_processing" }, [
                _c("h3", [_vm._v("We're Processing Your Video")]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "Your video will be processed and sent to the client directly."
                  ),
                ]),
              ]),
        ])
      : _c("div", [
          _c("input", {
            ref: "fileInput",
            staticClass: "videoUpload_fileInput",
            attrs: { type: "file", accept: "video/*" },
            on: { change: _vm.fileSelected },
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "videoUpload_dropzone m-t-lg",
              on: {
                drop: _vm.fileDropped,
                dragenter: function ($event) {
                  _vm.dropable = true
                },
                dragleave: function ($event) {
                  _vm.dropable = false
                },
              },
            },
            [
              _vm.state === "open"
                ? _c(
                    "div",
                    {
                      staticClass: "videoUpload_prompt",
                      class: { "is-droppable": _vm.dropable },
                    },
                    [
                      _c("i", { staticClass: "fa fa-cloud-upload fa-3x" }),
                      _vm._v(" "),
                      _c("h3", { staticClass: "text-upper" }, [
                        _vm._v("Drag and drop file"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "text-upper text-grey" }, [
                        _vm._v("Or"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-primary",
                          attrs: { type: "button" },
                          on: { click: _vm.chooseFile },
                        },
                        [_vm._v("\n          Choose File\n        ")]
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.state === "preview" || _vm.state === "uploading",
                      expression:
                        "state === 'preview' || state === 'uploading'",
                    },
                  ],
                  staticClass: "videoUpload_preview",
                },
                [
                  _c("video", {
                    ref: "player",
                    staticClass: "videoUpload_preview_player",
                    attrs: { controls: "" },
                  }),
                ]
              ),
              _vm._v(" "),
              _vm.state === "uploading"
                ? _c("div", { staticClass: "videoUpload_uploading" }, [
                    _c("h3", [
                      _vm._v(
                        "Uploading... " + _vm._s(_vm.uploadPercentage) + "%"
                      ),
                    ]),
                    _vm._v(" "),
                    _c("p", [_vm._v("Please don't leave the page")]),
                  ])
                : _vm._e(),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "m-t-lg flex justify-between" }, [
            _vm.state === "preview"
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-secondary",
                    attrs: { type: "button" },
                    on: { click: _vm.chooseFile },
                  },
                  [_vm._v("\n        Replace Video\n      ")]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-primary ml-auto",
                attrs: { type: "button", disabled: _vm.state !== "preview" },
                on: { click: _vm.completeBooking },
              },
              [_vm._v("\n        Complete Booking\n      ")]
            ),
          ]),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }